module.exports = VeeValidate;